import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const hour = {
  path: '/cashierStationary',
  component: Layout,
  name: 'cashierStationary',
  redirect: '/cashierStationary/index',
  children: [{
    path: '/cashierStationary/index',
    component: () => import('@/views/cashierStationary/index'),
    name: 'cashierStationary.index',
    meta: { title: i18n.t(`message.stasionary_cashier`) }
  }]
}

export default hour